<template>
	<div id="Bigcoffeegatheringdetails" class="centert">
		<div style="position: fixed;bottom: 5px;right: 50px;width: 50px;height: 50px;background-color: red;color: #FFF;z-index: 2;line-height: 50px;text-align: center;"
		 @click="fha">
			返回
		</div>
		<!-- 头标签 -->
		<dpubtop></dpubtop>
		<!-- 中间 -->
		<div class="Bigcoffdetails">
			<!-- 头部 -->
			<div class="pub_pub">
				<div class="pub_title">
					<div class="img_logo">
						<img src="../../../imges/lebiao/xptj.png" alt="">
					</div>
					<div class="title_t">
						<div class="imhg_ti">
							<img src="../../../imges/lebiao/xptj_font.png" alt="">
						</div>
						<div class="sm_t">
							<div style="float:left"><span>产品</span><span style="color:#D7230C;">详情</span></div>
							<div class="sm_pub">产品详情</div>
						</div>
					</div>
				</div>
				<div style="width: 0px;height: 36px;border: 1px solid #ececec;float: left;">
					<!-- 中间线 -->
				</div>
				<div class="ckgd_dh">
					<div class="sy">
						<div class="sy_img">
							<img src="../../../imges/details/sy.png" alt="">
						</div>
						<router-link class="sy_title" to="/" style="text-decoration: none;
							">首页</router-link>
					</div>
					<div class="jt" style="margin-top: 0px;">
						<img src="../../../imges/details/jt.png" alt="">
					</div>
					<div class="name">产品详情</div>
				</div>
			</div>
			<!-- 头部结束 -->
			<div class="top_bottom">
				<div class="top_bottom_T">
					<div class="dtiail_warp">
						<div class="dtiail_title">{{contents.title}}</div>
						<!-- 上传者信息 -->
						<div style="text-align: center;">
							<span>上传日期：{{getLocalTime(contents.create_time)}}</span>
							<span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;上传者：{{`${contents.username}`.substring(0,1)}}&nbsp;
								*&nbsp;* &nbsp;{{`${contents.username}`.substring(3,4)}}</span>
							<span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;阅读数：{{contents.view}}</span>
						</div>
						<!-- 内容渲染 -->
						<div class="cont_dtiail" style="height: 850px;overflow: scroll;text-align: center;" v-html="contents.content">
						</div>
					</div>
					<div style="width: 95%;margin: 0 auto;height: 100px;margin-top: 20px;">
						<!-- <Xguanyuedu></Xguanyuedu> -->
						<!-- 打赏分享 -->
						<!-- <tabmore :price="0" nologin_type="xptj" name="新品推荐" :tid="$route.query.id"></tabmore> -->
						<div class="scname" @click="sca"
							style="width: 50px;height: 30px;line-height: 30px;background-color: darkorange;text-align: center;font-size: 12px;font-weight: 900;color: #FFF;float: left;margin-left: 30%;">
							收藏
						</div>
						<!-- <div class="scname" @click="fxa"
							style="width: 50px;height: 30px;line-height: 30px;background-color: darkorange;text-align: center;font-size: 12px;font-weight: 900;color: #FFF;float: left;margin-left: 5px;">
							QQ好友分享
						</div> -->
						<div class="scname" @click="getShareInfo"
							style="width: 100px;height: 30px;line-height: 30px;background-color: darkorange;text-align: center;font-size: 12px;font-weight: 900;color: #FFF;float: left;margin-left: 5px;">
							微信分享
						</div>
						<div class="scname" @click="fxkj"
							style="width: 100px;height: 30px;line-height: 30px;background-color: darkorange;text-align: center;font-size: 12px;font-weight: 900;color: #FFF;float: left;margin-left: 5px;">
							QQ空间分享
						</div>
					</div>
				</div>
				<!-- 侧边栏 -->
				<div class="top_bottom_B">
					<rightlist></rightlist>
				</div>
			</div>
		</div>
		<!-- 中间结束 -->
		<!-- 尾标签 -->
		<myfooter></myfooter>
	</div>
</template>


<script>
	import http from "@/utils/http";
	// import wx from '../../commons/wxapi.js';
	import wx from 'weixin-js-sdk'
	export default {
		data() {
			return {
				options: [],
				searchData: {
					type: '职位',
					keyword: '' //搜索框查询关键字
				},
				value: '',
				id: this.$route.query.id,
				title: this.$route.query.title,
				contents: ''
			}
		},
		methods: {
			getLocalTime(nS) {
				return new Date(parseInt(nS) * 1000).toLocaleDateString().replace(/:\d{1,2}$/, ' ');
			},
			// wxfx() {
			// 	this.getShareInfo(this.title, this.url);
			// },
			getShareInfo() { //如果分享的内容会根据情况变化，那么这里可以传入分享标题及url
				var data = { //请求参数
					url: "http://localhost:8080/#" + this.$route.path + '?id=' + this.id,
				}

				//拿到后端给的这些数据
				// var g = new Date().getTime();
				wx.config({
					debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
					appId: 'wxc256e348c4032ebd', // 必填，公众号的唯一标识，填自己的！
					timestamp: timestamp, // 必填，生成签名的时间戳，刚才接口拿到的数据
					nonceStr: nonceStr, // 必填，生成签名的随机串
					signature: signature, // 必填，签名，见附录1
					jsApiList: [
						'onMenuShareTimeline',
						'onMenuShareAppMessage'
					]
				})

				wx.ready(function() {
					//分享到朋友圈
					// wx.onMenuShareTimeline({
					// 	title: tit, // 分享时的标题
					// 	link: fxUrl, // 分享时的链接
					// 	imgUrl: _this.pic, // 分享时的图标
					// 	success: function() {
					// 		console.log("分享成功");
					// 	},
					// 	cancel: function() {
					// 		console.log("取消分享");
					// 	}
					// });
					//分享给朋友
					wx.onMenuShareAppMessage({
						title: this.contents.title,
						desc: '海工人|船海智造360°综合服务平台',
						link: data.url,
						imgUrl: this.contents.picture,
						type: '',
						dataUrl: '',
						success: function() {
							console.log("分享成功");
						},
						cancel: function() {
							console.log("取消分享");
						}
					});
				})
			},
			fxa() {
				const share = {
					title: this.contents.title,
					desc: "海工人|船海智造360°综合服务平台",
					share_url: "http://localhost:8080/#" + this.$route.path + '?id=' + this.id
				};
				location.replace(
					"https://connect.qq.com/widget/shareqq/index.html?url=" +
					encodeURIComponent(share.share_url) +
					"&title=" +
					share.title +
					"&desc=" +
					share.desc
				);
			},
			fxkj() {
				const share = {
					title: this.contents.title,
					desc: "海工人|船海智造360°综合服务平台",
					image_url: [this.contents.picture],
					share_url: "http://localhost:8080/#" + this.$route.path + '?id=' + this.id
				};
				let image_urls = share.image_url.map(function(image) {
					return encodeURIComponent(image);
				});
				//跳转地址
				location.replace(
					"https://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?url=" +
					encodeURIComponent(share.share_url) +
					"&title=" +
					share.title +
					"&pics=" +
					image_urls.join("|") +
					"&summary=" +
					share.desc
				);
			},
			fha() {
				this.$router.go(-1); //返回上一层
			},
			async sca() {
				const loginInfo = JSON.parse(window.sessionStorage.getItem('user') || null)
				let res = await http.post('api/picture/personal_collection', {
					uid: loginInfo.id,
					title: this.contents.title,
					picture: this.contents.picture,
					url_link: this.$route.path + '?id=' + this.id + '&title=' + this.title,
					pc_link: this.$route.path + '?id=' + this.id + '&title=' + this.title,
				})
				if (res.data.code == 200) {
					this.$notify({
						title: '成功',
						message: '收藏成功',
						type: 'success'
					});
				} else {
					this.$notify({
						title: '失败',
						message: res.data.msg,
						type: 'error'
					});
				}
			},
		},
		async mounted() {
			let res = await http.get('index.php/bscard/wxapp.Sorts')
			this.options = res.data.data

			let res1 = await http.post('api/picture/qycb_detail', {
				id: this.id
			})
			console.log(res1)
			this.contents = res1.data.data.list
		},
		components: {
			// 尾标签,
			myfooter: resolve => require(['@/components/myfooter'], resolve),
			// 头标签
			dpubtop: resolve => require(['@/components/dpubtop/dpubtop'], resolve),
			//测标签
			rightlist: resolve => require(['@/components/dpubtop/rightList.vue'], resolve),
			//广澳
			PCguangao: resolve => require(['@/components/dpubtop/PCguangao.vue'], resolve),
			//相关阅读
			Xguanyuedu: resolve => require(['@/components/dpubtop/xgyd.vue'], resolve),
		}
	}
</script>

<style scoped>
	.centert {
		width: 1200px;
		margin: 0 auto;
	}

	.Bigcoffdetails {
		width: 100%;
	}

	.pub_pub {
		margin-top: 20px;
		border-radius: 0px !important;
		height: 36px;
	}

	.pub_title {
		width: 350px;
		float: left;
	}

	.ctu_::after,
	.pub_title::after {
		content: '';
		display: block;
		clear: both;
	}

	.pub_title>img {
		width: 100%;
		height: 100%;
	}

	.img_logo {
		float: left;
		width: 36px;
		height: 36px;
		overflow: hidden;
	}

	.title_t {
		float: left;
		height: 36px;
		margin-left: 12px;
		font-weight: 600;
		letter-spacing: 3px;
	}

	.imhg_ti {
		height: 12px;
		width: 120px;
		margin-top: -5px;
	}

	.imhg_ti>img {
		width: 100%;
		height: 100%;
	}

	.sm_t {
		height: 26px;
		line-height: 26px;
		font-size: 18px;
		margin-top: 8px;
	}

	.sm_pub {
		float: left;
		margin-left: 12px;
		font-size: 12px;
		color: #5e5d5d;
		cursor: pointer;
	}

	.sy::after,
	.ckgd_dh::after {
		content: '';
		display: block;
		clear: both;
	}

	.ckgd_dh {
		float: left;
		font-size: 12px;
		margin-left: 50px;
	}

	.ckgd_dh>div {
		float: left;
		height: 40px;
		line-height: 42px;
		color: #5e5d5d;
	}


	.name {
		line-height: 43px;
	}

	.sy_img {
		float: left;
		width: 20px;
		height: 20px;
	}

	.sy_img>img {
		margin-top: 13px;
		width: 100%;
		height: 100%;
	}

	.jt>img {
		margin-top: 10px;
	}

	.sy_title {
		float: left;
		height: 40px;
		line-height: 44px;
		margin-left: 6px;
		color: #5e5d5d;
	}

	.jt {
		width: 12px;
		height: 20px;
		margin-left: 6px;
		margin-right: 6px;
	}


	/* 头部结束 */
	.top_bottom {
		width: 100%;
		height: 1150px;
		box-shadow: #6e6e6e 0px 0px 10px;
		margin-top: 30px;
	}

	.top_bottom_T {
		width: 80%;
		height: 1150px;
		float: left;
	}

	.top_bottom_B {
		width: 20%;
		height: 1150px;
		float: left;
	}

	.dtiail_warp {
		width: 95%;
		margin: 0 auto;
	}

	.dtiail_title {
		margin-top: 40px;
		margin-bottom: 16px;
		text-align: center;
		font-size: 22px;
		color: #c00e0e;
	}

	.cont_dtiail>>>p>>>img {
		width: auto;
		height: 100%;
	}

	.cont_dtiail {
		overflow: hidden;
		margin-top: 20px;
		min-height: 300px;
	}

	.scname:hover {
		box-shadow: #6e6e6e 0px 0px 10px;
	}
</style>
